export default "__VITE_ASSET__Cw7bi3aW__"